import { GetRequestOptions } from "./grunt";

const getPth=process.env.REACT_APP_GRUNT_API+"/klaonica";
const StatusOk={status:200};

class Klaonica {
    constructor (id=0,sifra="",oib="",mb="",naziv="", mjesto="", ulkbr="", pbr="", posta="", opcina="", zupanija="") {
        this.id=id;
        this.sifra=sifra;
        this.mb=mb;
        this.oib=oib;
        this.naziv=naziv;
        this.mjesto=mjesto;
        this.ulkbr=ulkbr;
        this.pbr=pbr;
        this.posta=posta;
        this.opcina=opcina;
        this.zupanija=zupanija;
        
    }
}


const getKlaonice=async({orderbycolumn="naziv", orderby="asc",offset=0,limit=1000})=>{
    let _pth=getPth+`/${orderbycolumn}/${orderby}/${offset}/${limit}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const addKlaonica=async (klaonica)=>{
    try {
        let reqopt=GetRequestOptions("POST");
        reqopt.body=JSON.stringify(klaonica);
        const r=await fetch(getPth,reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod pohrane podatka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const updateKlaonica=async (klaonica)=>{
    try {
        let reqopt=GetRequestOptions("PUT");
        reqopt.body=JSON.stringify(klaonica);
        const r=await fetch(getPth,reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod ispravka podatka. " + ex.message, status: ex.status, name: ex.name};
    }
}

export {getKlaonice, addKlaonica, updateKlaonica, Klaonica};